import ImageBox from "./DeitiesImageBox";
import { useRouter } from "next/router";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { getCookieItem } from "@/utils/utils";
import { cdnBaseURL } from '@/commons/constants';

const DeitiesComponent = ({ data }) => {
  const imageBoxesData = data.boxesData;
  const boxHeight = data.boxHeight;
  const boxWidth = data.boxWidth;

  const router = useRouter();
  const handleClick = (categoryId) => {
    const languageName = getCookieItem("language_name");
    const locationName = getCookieItem("location_name");
    router.push(`/${languageName}/${locationName}/category/${categoryId}`);
  };

  const onClickViewAll = () => {
    // Location Default Setting
    // const location = getCookieItem("location");
    const languageName = getCookieItem("language_name");
    const locationName = getCookieItem("location_name");
    router.push(`/${languageName}/${locationName}/pooja`);
  };

  return (
    <div className="flex flex-col text-Default gap-4 md:gap-6 lg:gap-8 bg-white pb-4 pt-4 md:pt-8 lg:pt-12 md:pb-6 px-6 xs:px-8 sm:px-12 md:px-16 lg:px-20 xl:px-35 relative">
      <div className="flex flex-row justify-between items-start">
        <h3 className="flex flex-row justify-start items-start gap-4 text-md md:text-lg lg:text-2xl xl:text-[34px] 2xl:text-4xl font-bastoni tracking-wide">
          {data.title}
          <div className="flex align-top lg:my-1 items-center relative w-5 h-5 md:w-7 md:h-7 lg:w-8 lg:h-8 xl:w-10 xl:h-10">
            <ImageWrapper
              src={data.titleImage?.replace("bmpassets.s3.ap-south-1.amazonaws.com",cdnBaseURL)}
              alt="Title Image"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
        </h3>
        <button
          type="button"
          className="flex md:hidden text-sm cursor-pointer"
          onClick={onClickViewAll}
        >
          more
        </button>
        <button
          type="button"
          className="hidden md:flex text-sm cursor-pointer"
          onClick={onClickViewAll}
        >
          View all
        </button>
      </div>
      <div className="flex flex-row justify-start gap-4 overflow-x-auto scrollbar-hide">
        {imageBoxesData &&
          imageBoxesData.map((boxData, index) => {
            if (boxData.subCategoryName) {
              return (
                <ImageBox
                  key={`imgBox-${index}`}
                  name={boxData.subCategoryName}
                  imageUrl={boxData.imageLink}
                  altText={boxData.slug}
                  boxHeight={boxHeight}
                  boxWidth={boxWidth}
                  categoryid={boxData.slug}
                  onClick={handleClick}
                />
              );
            }
          })}
      </div>
      <div className="hidden md:flex flex-row justify-center -mt-5 ">
        <ImageWrapper
          src="/icons/Group640.svg"
          alt="Line Design"
          width={253}
          height={15}
        />
      </div>
    </div>
  );
};

export default DeitiesComponent;
